export default ({ request }) => ({
  ecomOverseasInvListApi(data = {}) {
    return request({
      url: '/ecom/overseas/inv/list',
      method: 'POST',
      data,
    })
  },
  ecomOverseasInvSelectTotalApi(data = {}) {
    return request({
      url: '/ecom/overseas/inv/selectTotal',
      method: 'POST',
      data,
    })
  },
})
